
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_55fkh_he50w_10",
  "textarea-readonly": "awsui_textarea-readonly_55fkh_he50w_55",
  "disabled": "awsui_disabled_55fkh_he50w_61",
  "textarea-invalid": "awsui_textarea-invalid_55fkh_he50w_69",
  "textarea-warning": "awsui_textarea-warning_55fkh_he50w_97",
  "textarea": "awsui_textarea_55fkh_he50w_55",
  "placeholder-visible": "awsui_placeholder-visible_55fkh_he50w_194",
  "invalid": "awsui_invalid_55fkh_he50w_230",
  "warning": "awsui_warning_55fkh_he50w_230",
  "textarea-disabled": "awsui_textarea-disabled_55fkh_he50w_233",
  "textarea-wrapper": "awsui_textarea-wrapper_55fkh_he50w_250",
  "editable-wrapper": "awsui_editable-wrapper_55fkh_he50w_255",
  "editable-element": "awsui_editable-element_55fkh_he50w_261",
  "primary-action": "awsui_primary-action_55fkh_he50w_268",
  "action-button": "awsui_action-button_55fkh_he50w_276",
  "secondary-content": "awsui_secondary-content_55fkh_he50w_281",
  "with-paddings": "awsui_with-paddings_55fkh_he50w_316",
  "action-stripe": "awsui_action-stripe_55fkh_he50w_326",
  "secondary-actions": "awsui_secondary-actions_55fkh_he50w_365",
  "with-paddings-and-actions": "awsui_with-paddings-and-actions_55fkh_he50w_383",
  "buffer": "awsui_buffer_55fkh_he50w_387",
  "token-container": "awsui_token-container_55fkh_he50w_393",
  "reference-wrapper": "awsui_reference-wrapper_55fkh_he50w_401",
  "trigger-base": "awsui_trigger-base_55fkh_he50w_405",
  "trigger-token": "awsui_trigger-token_55fkh_he50w_409",
  "paragraph": "awsui_paragraph_55fkh_he50w_415"
};
  